/** A contentblock should be shown if it's not-null or undefined, the content doesn't have a strict shape,
 * So we want to allow content blocks to show when the API returns an empty string("")
 * or empty rich text(`<p></p>`).
 */
export default function isContentBlockEmpty(
  block: string | null | undefined,
): boolean {
  return !block || block === "<p></p>";
}
